import {
  Box,
  Button,
  ButtonBase,
  Dialog,
  DialogContent,
  Grid,
  makeStyles,
  Popover,
  Typography,
  useMediaQuery,
} from '@material-ui/core';
import React from 'react';
import MapComponent from './MapContainer';
import {} from '@material-ui/icons';
import { SearchBlock } from './SearchBlock';
import {
  getCoords,
  getMapCenter,

} from 'services/Geolocation';
import { apiGet } from 'services/api';
import { get } from 'lodash';
import {searchPreProcessor} from "../../util/LocationUtils";
const useStyles = makeStyles((theme) => ({
  typography: {
    padding: theme.spacing(2),
  },
}));

const LocationSelector = ({
  onClose,
  open,
  dynamicJSONContent,
  rightSideBar,
  dialogUtils,
  ...props
}) => {
  const classes = useStyles();
  const [journey, setJourney] = React.useState({
    pickup: undefined,
    destination: undefined,
  });
  const [currentActive, setCurrentActive] = React.useState('');
  const [anchorEl, setAnchorEl] = React.useState(null);
  const [mapCenter, setMapCenter] = React.useState(undefined);
  const [mapBounds, setMapBounds] = React.useState([]);
  const isSmallScreeen = useMediaQuery('(max-height:768px)');

  let google = React.useRef({ current: {} });

  const handleClose = () => {
    setAnchorEl(null);
  };

  const popoverOpen = Boolean(anchorEl);

  const handleFieldClick = (event, field) => {
    setCurrentActive(field);
    setAnchorEl(event.currentTarget);
  };

  React.useEffect(() => {
    setMapCenter(
      getCoords({
        location: (journey.pickup || journey.destination || {}).location || '',
      })
    );
    if (journey.pickup && journey.destination) {
      const origin = getCoords({ location: journey.pickup.location });
      const destination = getCoords({ location: journey.destination.location });

      setMapCenter(getMapCenter(origin, destination));
      setMapBounds([origin, destination]);
    }
  }, [journey.pickup, journey.destination]);

  const queryFunction = (
    searchString,
    optionsList,
    setList,
    preProcessorResult
  ) => {
    apiGet(
      `/get-locations?search=${searchString}`,
      preProcessorResult.options
    ).then((response) => {
      setList(get(response, ['data'], {}).results);
    });
  };

  return (
    <Dialog
      open={open}
      onClose={onClose}
      aria-labelledby="form-dialog-title"
      PaperProps={{
        style: { width: '100%', maxWidth: '60vw', overflow: 'hidden' },
      }}
    >
      <DialogContent
        style={{
          padding: 0,
          overflow: 'auto',
          minHeight: '90vh',
          width: '100%',
          background: '#FDFDFF',
        }}
      >
        <div>
          <div
            style={{
              position: 'absolute',
              zIndex: 1,
              right: 0,
              height: 50,
              width: '100%',
              // padding: 10,
            }}
          >
            <div
              style={{
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
                borderBottom: '1px solid #E2E2E2',
                paddingLeft: 20,
              }}
            >
              <Typography
                style={{ fontSize: 17.5, color: '#505050', opacity: 1 }}
                noWrap={true}
                flex={1}
                spacing={1}
              >
                Select Pickup and Drop
              </Typography>
              <div>
                <Button
                  style={{
                    background:
                      'transparent linear-gradient(240deg, #7467F0 0%, #2896E9 100%) 0% 0% no-repeat padding-box',
                    color: '#ffffff',
                    margin: 5,
                  }}
                  onClick={() => {
                    dialogUtils.current.onDone(journey, '/location_picker');
                    onClose();
                  }}
                >
                  Submit
                </Button>
                <Button
                  style={{
                    background:
                      'transparent linear-gradient(0deg, #B70000 0%, #F70000 100%) 0% 0% no-repeat padding-box',
                    color: '#ffffff',
                    margin: 5,
                  }}
                  onClick={onClose}
                >
                  Close
                </Button>
              </div>
            </div>
            <div
              style={{
                padding: `${isSmallScreeen ? '20' : '40'}px 10px 0px 20px`,
                // maxHeight: isSmallScreeen ? '27.5vh' : '25vh',
                overflow: 'auto',
                background: '#ffffff',
              }}
            >
              <Box spacing={1} display="flex" alignItems="center">
                <div
                  style={{
                    color: '#505050',
                    marginRight: 10,
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    fontWeight: 'bold',
                    height: 25,
                    width: 25,
                    borderRadius: 12.5,
                    border: '2.5px solid #505050',
                  }}
                >
                  P
                </div>
                <ButtonBase style={{ width: '100%', textAlign: 'left' }}>
                  <div
                    onClick={(event) => handleFieldClick(event, 'pickup')}
                    style={{
                      flex: 1,
                      border: '1px solid #E5E5E5',
                      borderRadius: 5,
                      fontSize: 17.5,
                      padding: 10,
                      cursor: 'pointer',
                      color: '#909090',
                    }}
                  >
                    {(journey.pickup || {}).title || 'Select Pickup point'}
                  </div>
                </ButtonBase>
              </Box>
              <Grid spacing={1}>
                <Grid item>
                  <div style={{ padding: '2.5px 7.5px' }}>
                    <div
                      style={{
                        height: 5,
                        width: 5,
                        borderRadius: 2.5,
                        margin: '6px 3px',
                        background: '#505050',
                      }}
                    />
                    <div
                      style={{
                        height: 5,
                        width: 5,
                        borderRadius: 2.5,
                        margin: '6px 3px',
                        background: '#505050',
                      }}
                    />
                  </div>
                </Grid>
              </Grid>
              <Box spacing={1} display="flex" alignItems="center">
                <div
                  style={{
                    color: '#505050',
                    marginRight: 10,
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    fontWeight: 'bold',
                    height: 25,
                    width: 25,
                    borderRadius: 12.5,
                    border: '2.5px solid #505050',
                  }}
                >
                  D
                </div>
                <ButtonBase style={{ width: '100%', textAlign: 'left' }}>
                  <div
                    onClick={(event) => handleFieldClick(event, 'destination')}
                    style={{
                      flex: 1,
                      border: '1px solid #E5E5E5',
                      borderRadius: 5,
                      fontSize: 17.5,
                      padding: 10,
                      cursor: 'pointer',
                      color: '#909090',
                    }}
                  >
                    {(journey.destination || {}).title || 'Select Destination'}
                  </div>
                </ButtonBase>
              </Box>
            </div>
          </div>
        </div>
        <div>
          <MapComponent
            centerAroundCurrentLocation={true}
            zoom={14}
            googleRef={(ref) => {
              google.current.googleRef = ref;
              google.current.mapDirector = new ref.maps.DirectionsService();
            }}
            containerStyle={{
              bottom: 0,
              // height: isSmallScreeen ? '55vh' : '61vh',
              height: 'calc(100% - 260px)',
            }}
            markers={[
              ...(journey.pickup
                ? [
                    {
                      name: 'Pickup',
                      icon: 'map-pin-red',
                      marker: journey.pickup,
                      google: google.current.googleRef,
                    },
                  ]
                : []),
              ...(journey.destination
                ? [
                    {
                      name: 'Destination',
                      icon: 'map-pin-green',
                      marker: journey.destination,
                      google: google.current.googleRef,
                    },
                  ]
                : []),
            ]}
            center={mapCenter}
            bounds={mapBounds}
            polylineJourney={{
              pickup: (journey.pickup || {}).location,
              destination: (journey.destination || {}).location,
            }}
          />
        </div>
        <Popover
          open={popoverOpen}
          anchorEl={anchorEl}
          onClose={handleClose}
          anchorOrigin={{
            vertical: 'bottom',
            horizontal: 'left',
          }}
          transformOrigin={{
            vertical: 'top',
            horizontal: 'left',
          }}
          PaperProps={{
            style: {
              width: '50vw',
            },
          }}
        >
          <SearchBlock
            onSelect={(selected) => {
              setJourney({ ...journey, [currentActive]: selected });
              handleClose();
            }}
            queryFunction={queryFunction}
            isAsyncSearch={true}
            searchPreProcessor={searchPreProcessor}
          />
        </Popover>
      </DialogContent>
    </Dialog>
  );
};

export default LocationSelector;
